// Base64 signatures of the common bitmap formats (the API sends a bare base64
// string without a data: prefix, so the MIME must be sniffed).
const LAYOUT_IMAGE_SIGNATURES: { prefix: string; mime: string }[] = [
  { prefix: 'iVBOR', mime: 'image/png' },
  { prefix: '/9j/', mime: 'image/jpeg' },
  { prefix: 'R0lGOD', mime: 'image/gif' },
  { prefix: 'Qk', mime: 'image/bmp' },
  { prefix: 'UklGR', mime: 'image/webp' },
];

// base64-encoded bitmap (canvas/object backgroundImage) → data URL usable as
// an image source. Already prefixed values pass through unchanged.
export const getLayoutImageDataUrl = (base64: string): string => {
  const trimmed = base64.trim();

  if (trimmed.startsWith('data:')) {
    return trimmed;
  }

  const signature = LAYOUT_IMAGE_SIGNATURES.find(({ prefix }) =>
    trimmed.startsWith(prefix)
  );

  return `data:${signature?.mime ?? 'image/png'};base64,${trimmed}`;
};
